module.exports = "https://deal-img.imgix.net/consumer/modern/yacht-expert.f6beb40e.jpg";